import axios from "axios";
import { MAIN_URL, getApiHeaders } from "../Configurations/Urls";
import toast from "react-hot-toast";

function handleAuthError(error) {
  if (error.response && error.response.status === 401) {
    toast.error("Session Expired!");
    window.location.href = "/login";
  }
}

export async function fetchWhatsAppTemplates(organizationId, status = "APPROVED") {
  try {
    const response = await axios.get(`${MAIN_URL}/api/ems/whatsapp/templates`, {
      headers: getApiHeaders(),
      params: {
        organization_id: organizationId,
        status,
      },
    });
    return response.data;
  } catch (error) {
    handleAuthError(error);
    throw error;
  }
}

export async function sendWhatsAppMessages(payload) {
  try {
    const response = await axios.post(`${MAIN_URL}/api/ems/whatsapp/send`, payload, {
      headers: getApiHeaders(),
    });
    return response.data;
  } catch (error) {
    handleAuthError(error);
    throw error;
  }
}

export async function fetchWhatsAppHistory(organizationId, perPage = 20, page = 1) {
  try {
    const response = await axios.get(`${MAIN_URL}/api/ems/whatsapp/history`, {
      headers: getApiHeaders(),
      params: {
        organization_id: organizationId,
        per_page: perPage,
        page,
      },
    });
    return response.data;
  } catch (error) {
    handleAuthError(error);
    throw error;
  }
}

export async function searchStudentsForWhatsApp(organizationId, search = "") {
  try {
    const response = await axios.post(
      `${MAIN_URL}/api/ems/students/filtered`,
      {
        organization_id: organizationId,
        page: 1,
        per_page: 25,
        search: search || undefined,
      },
      { headers: getApiHeaders() }
    );
    return response.data;
  } catch (error) {
    handleAuthError(error);
    throw error;
  }
}

export async function searchLeadsForWhatsApp(organizationId, search = "") {
  try {
    const response = await axios.post(
      `${MAIN_URL}/api/ems/leads/filtered`,
      {
        organization_id: organizationId,
        page: 1,
        per_page: 25,
        search: search || undefined,
      },
      { headers: getApiHeaders() }
    );
    return response.data;
  } catch (error) {
    handleAuthError(error);
    throw error;
  }
}
